<template>
  <mmp-modal v-bind="componentAttrs" title="개인정보 처리방침" v-on="listeners">

    <template v-slot:header>
      <div class="popup_title">
        ㈜멀티캠퍼스 개인정보처리방침
      </div>
      <button type="button" class="btn_close" @click="$emit('close')"><span class="blind">팝업 닫기</span></button>
    </template>

    <template v-slot:content>
      <!-- 탭 메뉴 -->
      <div class="mmp_privacy_tabs">
        <ul>
          <li>
            <button
              :class="{'active': activeTabIdx === 0}"
              type="button"
              @click="activeTabIdx = 0"
            >개인정보처리방침</button>
          </li>
          <li>
            <button
              :class="{'active': activeTabIdx === 1}"
              type="button"
              @click="activeTabIdx = 1"
            >알기 쉬운 개인정보처리방침</button>
          </li>
        </ul>
      </div>
      <!-- // 탭 메뉴 -->

      <!--
        [NOTE] notice box
        - 'mmp_privacy_policy' 클래스 추가
      -->
      <div class="notice_box mmp_privacy_policy">
        <!-- <div id="agreebox-wrap" class="agreebox-wrap"> -->
        <div v-show="activeTabIdx===0" id="agreebox-wrap1" class="agreebox-wrap tab_cont_0">
          <!--
            [NOTE] select box
            - 셀렉트박스 위치 변경 (하단 -> 상단)
          -->
          <div class="select_box">
            <select v-model="histListSeleted" title="시행일자 기준">
              <option
                v-for="(histListObj, idx) in histList" :key="idx"
                :value="histListObj.value">
                {{ histListObj.tit }}
              </option>
            </select>
          </div>
          <!-- // select box -->

          <!-- 'v-dompurify-html'사용 시 rawHtml 내용에 <link rel="stylesheet" href="https://el.multicampus.com/de_common/mulcam/css/privacy.css"> 사라짐 'v-html'로 대체 -->
          <!-- <div v-dompurify-html="rawHtml"/> -->
          <div v-html="rawHtml"/>
        </div>

        <!--
          알기 쉬운 개인정보처리방침 (신규 구조)
          - [NOTE] 'tab_cont_1' 클래스 추가
        -->
        <div
          v-show="activeTabIdx===1"
          id="agreebox-wrap2"
          class="agreebox-wrap tab_cont_1"
        >
          <!--
            [NOTE] DB content
            - privacy.css 파일 링크까지 DB 콘텐츠로 저장
          -->
          <div v-html="mobRawHtml"/>
        </div>
        <!-- // 알기 쉬운 개인정보처리방침 -->

      </div>
      <!-- // notice box -->

    </template>
    <template v-slot:footer>
      <div />
    </template>
  </mmp-modal>
</template>

<script>
import { isEmpty, map } from 'lodash'
export default {
  name: 'NrwPrivacyPolicy',
  mixins: [],
  data () {
    return {
      activeTabIdx: 0, // 활성 탭 메뉴 index (default 0)
      rawHtml: '',
      mobRawHtml: '',
      histListStr: '',
      histListSeleted: ''
    }
  },
  computed: {
    isValidParam () {
      return true
    },
    histList () {
      if (isEmpty(this.histListStr)) {
        return []
      }

      var rtList = map(this.histListStr.split('|'), function (val, idx) {
        return {
          tit: val.split('^')[0],
          value: val.split('^')[1]
        }
      })

      return rtList
    }
  },
  watch: {
    'histListSeleted': {
      handler: function (nval, oval) {
        if (nval !== oval) {
          this.getPrivacyPolicyTerms(this.histListSeleted)
        }
      }
    }
  },
  created () {},
  beforeDestroy () {},
  mounted () {
    this.getPrivacyPolicyTerms()
  },
  methods: {
    addEvt () {
      /**
       * [NOTE] 앵커 스크롤 이벤트 등록
       * - 팝업 콘텐츠 내 바로가기 링크 클릭시 팝업 스크롤 위치 이동
       */
      let i, anchor, trigger, tId
      const anchors = document.querySelectorAll('.agree-link a')

      for (i = 0; i < anchors.length; i++) {
        anchor = anchors[i]
        anchor.addEventListener('click', (e) => {
          trigger = e.target
          e.preventDefault()
          // console.log('trigger.tagName: ', trigger.tagName)
          // console.log("trigger.getAttribute('href'):", trigger.getAttribute('href'))

          if (trigger.tagName === 'A') {
            tId = trigger.getAttribute('href').replace('#', '')
          } else {
            tId = trigger.parentNode.getAttribute('href').replace('#', '')
          }

          this.scrollToAnchor(tId)
        })
      }
    },
    /**
     * [NOTE] 앵커 클릭시 해당 위치로 팝업 콘텐츠 스크롤
     * @param tId 앵커 클릭시 이동할 타켓 id값 (앵커의 href에서 받아옴)
     */
    scrollToAnchor (tId) {
      const pHeader = document.querySelector('.popup_wrap #header')
      const pCont = document.querySelector('.popup_wrap .popup_content')
      const pHeaderH = pHeader.offsetHeight
      const targetEl = document.getElementById(tId)
      const targetOffsetTop = targetEl.offsetTop
      const targetStyle = targetEl.currentStyle || window.getComputedStyle(targetEl)
      const targetMgt = Number(targetStyle.marginTop.replace('px', ''))

      // console.log('targetOffsetTop:', targetOffsetTop)
      // console.log('pHeaderH:', pHeaderH)
      // console.log('targetMgt:', targetMgt)
      // console.log(pCont)

      pCont.scrollTo({
        top: targetOffsetTop - pHeaderH - targetMgt,
        behavior: 'smooth'
      })
    },
    async getPrivacyPolicyTerms (termsAgrmtSno) {
      var params = {}

      if (!isEmpty(termsAgrmtSno)) {
        params.termsAgrmtSno = termsAgrmtSno
      }

      var getPrivacyPolicyTermsResult = await this.$http.busn.getPrivacyPolicyTerms(this, params)

      if (getPrivacyPolicyTermsResult.data.status === 'OK') {
        this.$set(this, 'rawHtml', getPrivacyPolicyTermsResult.data.data.privacyPolicyTerms.termsCntnt )
        console.log('rawHtml ::: ', getPrivacyPolicyTermsResult.data.data)
        this.$set(this, 'mobRawHtml', getPrivacyPolicyTermsResult.data.data.privacyPolicyMobileWeb.mobileTermsCntnt )

        if (isEmpty(this.histListSeleted)) {
          this.$set(this, 'histListSeleted', getPrivacyPolicyTermsResult.data.data.privacyPolicyTerms.histList.split('|')[0].split('^')[1])
        }
        this.$set(this, 'histListStr', getPrivacyPolicyTermsResult.data.data.privacyPolicyTerms.histList )
      }

      // ajax 끝나고 실행
      setTimeout(() => {
        this.addEvt()
      }, 1000)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/layouts/NrwPrivacyPolicyModal.vue